import * as React from "react";
import { useGetProductsBySkus } from "@grandvisionhq/fun-search";
import { ProductBlockRow } from "@grandvisionhq/lib-visuals";
import { isDefined } from "@grandvisionhq/utils";
import { ProductListingRowBlock } from "../ProductListingRowBlock/components/ProductListingRow/components/ProductListingRowBlock/ProductListingRowBlock.js";
const ProductListingRow = ({ skus }) => {
  const { listingProducts, loading } = useGetProductsBySkus({ skus });
  const products = React.useMemo(() => {
    if (!listingProducts || !listingProducts.length) {
      return [];
    }
    const productMap = /* @__PURE__ */ new Map();
    listingProducts.forEach((product) => {
      productMap.set(product.masterVariant.sku, product);
      product.variants.forEach((variant) => {
        productMap.set(variant.sku, product);
      });
    });
    return skus.map((sku) => ({
      product: productMap.get(sku),
      selectedVariant: sku
    })).filter(({ product }) => isDefined(product));
  }, [listingProducts, skus]);
  return /* @__PURE__ */ React.createElement(ProductBlockRow, { isLoading: loading }, products.map((item) => /* @__PURE__ */ React.createElement(
    ProductListingRowBlock,
    {
      key: item.selectedVariant ?? item.product.slug,
      listingProduct: item.product,
      selectedVariant: item.selectedVariant
    }
  )));
};
export {
  ProductListingRow
};
//# sourceMappingURL=ProductListingRow.js.map
